import {
  ColorValues,
  Colors,
  Flex,
  IconCamera,
  IconEmptyZzim,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { isNil, isNotNil } from 'shared/src/utils';

const COVER_SIZE = 180;

interface CoverImageProps {
  coverImage?: string | null;
  isEditMode?: boolean;
  onPress?: () => void;
}

export const CoverImage = ({
  coverImage,
  isEditMode = false,
  onPress,
}: CoverImageProps) => {
  return (
    <Flex.Center backgroundColor={'content_always_white'}>
      <Flex onPress={isEditMode ? onPress : undefined}>
        {isNotNil(coverImage) ? (
          <RemoteImage
            uri={coverImage}
            width={COVER_SIZE}
            height={COVER_SIZE}
            borderRadius={'medium'}
          />
        ) : (
          <Flex.Center
            width={COVER_SIZE}
            height={COVER_SIZE}
            backgroundColor={'bg_secondary'}
            borderRadius={'medium'}
          >
            {!isEditMode && (
              <IconEmptyZzim size={72} fill={Colors.border_secondary} />
            )}
          </Flex.Center>
        )}
        {isEditMode && (
          <Flex.Center
            position={'absolute'}
            top={0}
            left={0}
            right={0}
            bottom={0}
            gap={2}
            padding={{ top: 20 }}
            backgroundColorValue={ColorValues.alpha_dark40}
            borderRadius={'medium'}
          >
            <IconCamera size={24} fill={Colors.content_always_white} />
            {isNil(coverImage) && (
              <Typography type={'subtitle4'} color={'content_always_white'}>
                서랍 커버
              </Typography>
            )}
          </Flex.Center>
        )}
      </Flex>
    </Flex.Center>
  );
};
